import { Text } from 'pixi.js'
import gsap from 'gsap'
import { formatMoney } from '../../framework/core/format'

// 數字滾動顯示 — 取代 Unity NumberSprite（改用 GSAP 補間數值）。
export class NumberCounter extends Text {
  private current = 0
  private tween: gsap.core.Tween | null = null

  constructor(prefix = '') {
    super({
      text: prefix,
      style: { fill: 0xffe9a8, fontWeight: 'bold', fontFamily: 'Arial', fontSize: 40 },
    })
    this.anchor.set(0.5)
    this.format()
  }

  setValue(value: number): void {
    this.killTween()
    this.current = value
    this.format()
  }

  countTo(target: number, duration = 0.8): Promise<void> {
    this.killTween()
    return new Promise<void>((resolve) => {
      const proxy = { v: this.current }
      this.tween = gsap.to(proxy, {
        v: target,
        duration,
        ease: 'power1.out',
        onUpdate: () => {
          this.current = proxy.v
          this.format()
        },
        onComplete: () => {
          this.current = target
          this.format()
          this.tween = null
          resolve()
        },
      })
    })
  }

  /** 銷毀時呼叫，避免 tween 在已移除物件上續跑（取代 DOTween SetLink）。 */
  killTween(): void {
    this.tween?.kill()
    this.tween = null
  }

  private format(): void {
    this.text = formatMoney(this.current)
  }
}
